export default __webpack_public_path__ + "static/media/NunitoSans-ExtraLight.fdbf582a.woff";